import { z } from 'zod';
import { supportedChainSlugSchema } from './common.js';
const requiredStringSchema = z.string().min(1);
export const getProtocolsParamsSchema = z.object({
    category: requiredStringSchema.optional(),
    chain: requiredStringSchema.optional(),
}).strict();
export const getRegistrySlugsParamsSchema = z.object({
    category: requiredStringSchema.optional(),
    chain: requiredStringSchema.optional(),
}).strict();
export const registrySlugsDataSchema = z.array(requiredStringSchema);
export const getProtocolParamsSchema = z.object({
    slug: requiredStringSchema,
}).strict();
export const getRegistryContractsParamsSchema = z.object({
    slug: requiredStringSchema,
    chain: requiredStringSchema.optional(),
}).strict();
export const getRegistryAddressParamsSchema = z.object({
    slug: requiredStringSchema,
    contract: requiredStringSchema,
    chain: requiredStringSchema,
}).strict();
export const registryCategorySchema = z.object({
    name: requiredStringSchema,
    slug: requiredStringSchema,
}).strict();
export const registryChainSchema = z.object({
    name: requiredStringSchema,
    slug: supportedChainSlugSchema,
}).strict();
export const protocolEntrySchema = z.object({
    name: requiredStringSchema,
    slug: requiredStringSchema,
    url: requiredStringSchema,
    category: requiredStringSchema,
    description: requiredStringSchema,
    version: requiredStringSchema.optional(),
    chains: z.array(requiredStringSchema),
}).strict();
export const protocolContractEntrySchema = z.object({
    name: requiredStringSchema,
    abi: requiredStringSchema.optional(),
    address: requiredStringSchema.optional(),
    addresses: z.record(z.string(), z.string()).optional(),
}).strict();
export const protocolDetailSchema = protocolEntrySchema.extend({
    contracts: z.record(z.string(), protocolContractEntrySchema),
    hallmarks: z.array(z.tuple([requiredStringSchema, requiredStringSchema])).optional(),
});
export const protocolContractsDataSchema = z.object({
    protocol: requiredStringSchema,
    chain: requiredStringSchema,
    contracts: z.record(z.string(), protocolContractEntrySchema),
}).strict();
export const protocolAddressDataSchema = z.object({
    protocol: requiredStringSchema,
    contract: requiredStringSchema,
    chain: requiredStringSchema,
    address: requiredStringSchema,
}).strict();
